var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
var StyledLabelValue = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
export var StyledText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return ({ ...props.componentStyle }); });
export default function LabelValue(props) {
    return (React.createElement(StyledLabelValue, null,
        React.createElement(StyledText, __assign({}, props), props.label),
        props.type && React.createElement(ValueByType, __assign({}, props))));
}
var ValueTypes = {
    DATE: 'date',
    TIME: 'time',
};
function ValueByType(props) {
    switch (props.type) {
        case ValueTypes.DATE:
            return React.createElement(DateValue, null);
        case ValueTypes.TIME:
            return React.createElement(TimeValue, null);
    }
    return React.createElement(StyledText, null, "NA");
}
function DateValue() {
    return React.createElement(StyledText, null, moment().format('DD MMM YY'));
}
function TimeValue() {
    var _a = useState(moment()), date = _a[0], setDate = _a[1];
    useEffect(function () {
        var timer = setInterval(function () {
            setDate(moment());
        }, 1000);
        return function () {
            clearInterval(timer);
        };
    }, []);
    return React.createElement(StyledText, null, date.format('hh:mm:ss'));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=LabelValue.js.map